import { useEffect, useRef } from 'react'

// source: https://overreacted.io/making-setinterval-declarative-with-react-hooks/
export function useInterval (callback: () => void, delay: number) {
  const savedCallback = useRef<() => void>()

  // Remember the latest callback
  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  // Setup the interval
  useEffect(() => {
    function tick () {
      savedCallback.current?.()
    }

    if (delay !== null) {
      const id = setInterval(tick, delay)
      return () => clearInterval(id)
    }
  }, [delay])
}
